import Dexie, { Table } from "dexie";

export interface Jewelry {
    s: string; // type
    n: string; // name
    i?: string; // id
    l?: string; // link
    f?: File; // file
}

interface Diamond extends Jewelry {
    id?: number;
    createdAt: number;
}

// trove
export class Diamonds extends Dexie {
    private diamonds: Table<Diamond, number>;

    constructor() {
        super("Diamonds");
        this.version(1).stores({
            diamonds: "++id, name, type, createdAt"
        });

        this.diamonds = this.table("diamonds");
    }

    async add(jewelry: Jewelry): Promise<number> {
        const id = await this.diamonds.add({
            createdAt: Date.now(),
            ...jewelry
        });
        return id;
    }

    async remove(id: number): Promise<void> {
        await this.diamonds.delete(id);
    }

    async clear(): Promise<void> {
        await this.diamonds.clear();
    }
}
